import {useContext, useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {useTotalMatchesCount} from '../hooks/useTotalMatchesCount';

import DashboardHeader from './DashboardHeader';
import MatchesGraph from './MatchesGraph';
import {RejectionsRates} from './RejectionsRates';
import {UserContext} from '../../../../../contexts/UserContext/UserContext';
import {CompanyAdminRoleData} from '../../../../../types/User';

export default function CompanyAnalyticsDashboard() {
  const {t} = useTranslation();

  const {currentUser} = useContext(UserContext);
  const companyId = useMemo(() => {
    return (currentUser?.role?.data as CompanyAdminRoleData)?.companyId;
  }, [currentUser]);

  const {matchesTotalCount, error} = useTotalMatchesCount(companyId);

  return (
    <Grid container sx={{width: '100%', height: '100%'}}>
      <Grid item xs={12}>
        <Typography variant='h1'>{t('companyRecruitingDashboard.title')}</Typography>
      </Grid>
      <Grid item xs={12}>
        {error ? (
          <Typography variant='h4' mb={3} align='center'>
            {t('companyRecruitingDashboard.header.errorHandling')}
          </Typography>
        ) : (
          <DashboardHeader matchesTotalCount={matchesTotalCount} />
        )}
      </Grid>
      <Grid item xs={12}>
        <MatchesGraph companyId={companyId} />
      </Grid>
      <Grid item xs={12}>
        <RejectionsRates companyId={companyId} />
      </Grid>
    </Grid>
  );
}
